import { useTheme } from '@emotion/react';
import { Box, Typography } from '@mui/material';

import { customTheme } from '../../shared/theme/theme';

import PageLayout from '../../components/shared/page-layout/page-layout.component';

import { useCUStyles } from './contact-us.styles';

const ContactUs = () => {
  const theme = useTheme(customTheme);
  const classes = useCUStyles();

  return (
    <PageLayout heading={`Let's get in touch!`}>
      <Box className={classes.cuWrapper}>
        <Box className={classes.mapWrapper}>
          <iframe
            title='fspl-map'
            src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3684.3209529492074!2d88.34790801545192!3d22.56709628518561!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a0277a6fca03c55%3A0xca3911bccc636823!2s9%2C%20Crooked%20Lane%2C%20Esplanade%2C%20Chowringhee%20North%2C%20Bow%20Barracks%2C%20Kolkata%2C%20West%20Bengal%20700069!5e0!3m2!1sen!2sin!4v1648362744291!5m2!1sen!2sin'
            width='800'
            height='360'
            style={{ border: 0, margin: '0 auto'}}
            allowFullScreen=''
            loading='lazy'
            referrerPolicy='no-referrer-when-downgrade'
          ></iframe>
        </Box>
        <Box className={classes.contactDetails}>
          <div>
            <Typography className={classes.address}>
              Address <br />
              9, Crooked Lane
              <br /> 4th Floor, Kolkata, 700069
            </Typography>
            <Typography>
              Email us at{' '}
              <a
                href='mailto:thegraphshala@gmail.com'
                style={{ color: theme.palette.primary.main }}
              >
                thegraphshala@gmail.com
              </a>
            </Typography>
          </div>

          <Typography>
            Monday - Friday | 11AM - 7PM IST
            <br />
            Closed on Saturday & Sunday
          </Typography>
        </Box>
      </Box>
    </PageLayout>
  );
};

export default ContactUs;
